import React from 'react';
import { Chip } from '../Styles';
import { isMapped, isUnmapped } from './helper';

function AiSkuMappingStatus({ status }) {
  if (isMapped(status)) {
    return (
      <Chip
        style={{
          backgroundColor: '#D8FAD9',
          color: '#666',
          fontWeight: 600,
          fontSize: '14px',
        }}
        label={status}
      />
    );
  } else if (isUnmapped(status)) {
    return (
      <Chip
        style={{
          backgroundColor: '#fde7d9',
          color: '#666',
          fontWeight: 600,
          fontSize: '14px',
        }}
        label={status}
      />
    );
  }
  return null;
}

export default AiSkuMappingStatus;
